// The Cognito group the DCH API treats as superadmin.
export const SUPER_ADMIN_GROUP = 'DCHAdmins';

function tokenGroups(token) {
  try {
    const { groups } = JSON.parse(atob(token.split('.')[1]));
    return Array.isArray(groups) ? groups : [];
  } catch (error) {
    return [];
  }
}

export function isSuperAdminToken(token) {
  return !!token && tokenGroups(token).includes(SUPER_ADMIN_GROUP);
}

// Catalogue sources only a superadmin sees. They have no parser, so the config's available sources,
// which list the parsers, leave them out; each is merged with the company's source when it has one.
export function withSuperAdminSources(available, catalogue, connected, isSuperAdmin) {
  if (!isSuperAdmin) return available;
  const listed = new Set(available.map((source) => source.id));
  const added = catalogue
    .filter((source) => source.superadmin_only && !listed.has(source.id))
    .map((source) => ({ ...source, ...connected.find((cs) => cs.id === source.id) }));
  return [...available, ...added];
}

// The base URL to send for a source: only one a superadmin changed. The API refuses it from anyone
// else, since the URL is where DCH sends the source's credentials and signed platform tokens.
export function baseUrlToSend(isSuperAdmin, stored, edited) {
  const url = (edited || '').trim();
  return isSuperAdmin && url && url !== stored ? url : undefined;
}
